import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { lang, language, supporterGiftsList, changeRule, topGiftsList, tabShow } = this.props
    let isShow = () => {
      if (tabShow == '0') {
        return lang.rewardKing
      } else if (tabShow == '1') {
        return lang.rewardSupporter
      } else {
        return lang.rewardRoom
      }
    }
    return (
      <div className="rewards-pk">
        {/* head */}
        <div className="rewards-header">
          <div className={`title ${language}`}>
            <p>{isShow()}</p>
          </div>
        </div>

        {/* body */}
        <div className="rewards-body">
          {/* 奖励1 */}
          {topGiftsList.map((item, index) => {
            return (
              // rewards-3
              <div className="rewards-wrap" key={index}>
                {/* title */}
                <div className="rewards-title">
                  <div className="left">
                    <img src="/img/activity/pk/left.png" alt="" />
                  </div>
                  <div className="center">{item.title[language]?item.title[language]:item.title['en']}</div>
                  <div className="right">
                    <img src="/img/activity/pk/right.png" alt="" />
                  </div>
                </div>
                {/* content */}
                <div className="rewards-content">
                  {item.list.map((item2, index) => {
                    return (
                      <div className="rewards-one" key={index}>
                        <div className="box">
                          <div className="pic">
                            <img src={item2.img} alt="" />
                          </div>
                          <div className="name" dangerouslySetInnerHTML={{ __html: item2.name[language] || '' }}></div>
                        </div>
                      </div>
                    )
                  })}

                  {/* reward2 */}

                  <div className="rewards-one">
                    {item.list2.map((item3, index) => {
                      return (
                        <div className="box" key={index}>
                          <div className="pic">
                            <img src={item3.img} alt="" />
                          </div>
                          <div className="name" dangerouslySetInnerHTML={{ __html: item3.name[language] || '' }}></div>
                        </div>
                      )
                    })}
                  </div>

                  {/* reward3 */}
                  <div className="rewards-two">
                    <div className="out-box">
                      {item.list3.map((item4, index) => {
                        return (
                          <div className="box" key={index}>
                            <div className="pic">
                              <img src={item4.img} alt="" />
                            </div>
                            <div className="name" dangerouslySetInnerHTML={{ __html: item4.name[language] || '' }}></div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
          {/* 奖励2.3 */}
          {supporterGiftsList.map((item, index) => {
            return (
              <div className="rewards-wrap" key={index}>
                {/* title */}
                <div className="rewards-title">
                  <div className="left">
                    <img src="/img/activity/pk/left.png" alt="" />
                  </div>
                  <div className="center">{item.title[language]?item.title[language]:item.title['en']}</div>
                  <div className="right">
                    <img src="/img/activity/pk/right.png" alt="" />
                  </div>
                </div>
                {/* content */}
                <div className="rewards-content">
                  {/* reward2 */}
                  <div className="rewards-one">
                    {item.list.map((item2, index) => {
                      return (
                        <div className="box" key={index}>
                          <div className="pic">
                            <img src={item2.img} alt="" />
                          </div>
                          <div className="name" dangerouslySetInnerHTML={{ __html: item2.name[language] || '' }}></div>
                        </div>
                      )
                    })}
                  </div>
                  {/* reward3 */}
                  <div className="rewards-two">
                    <div className="out-box">
                      {item.list2.map((item3, index) => {
                        return (
                          <div className="box" key={index}>
                            <div className="pic">
                              <img src={item3.img} alt="" />
                            </div>
                            <div className="name" dangerouslySetInnerHTML={{ __html: item3.name[language] || '' }}></div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}


          <div className="reward-btn" onClick={changeRule.bind(this, { state: true, value: '2' })}>
            {lang.rewardtitle}
          </div>
        </div>
        {/* foot */}
        <div className="rewards-footer"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/pkReward/index.js